import { pipingEngineeringService } from '../../infrastructure/services/piping-engineering-service.js';
import type { Equipment } from '../../equipment/equipment-domain.js';

export class PipingFormBuilder {
  static async renderPipingFields(eq: Partial<Equipment>, relatedEquipments: Equipment[]): Promise<string> {
    await pipingEngineeringService.loadCatalogs();

    const families = pipingEngineeringService.getMaterialFamilies();
    const specs = eq.materialFamily ? pipingEngineeringService.getSpecifications(eq.materialFamily) : [];
    const grades = (eq.materialFamily && eq.materialSpecification) ? pipingEngineeringService.getGrades(eq.materialFamily, eq.materialSpecification) : [];
    
    const standard = eq.dimensionalStandard || (eq.materialFamily ? pipingEngineeringService.getDimensionalStandard(eq.materialFamily) : 'ASME B36.10M');
    const npsList = pipingEngineeringService.getAvailableNPS(standard);
    const schedules = eq.nps ? pipingEngineeringService.getAvailableSchedules(eq.nps, standard) : [];
    
    const pipingClasses = pipingEngineeringService.getPipingClasses();

    return `
      <!-- CAMPOS DE ENGENHARIA DE TUBULAÇÃO -->
      <div id="piping-engineering-container" style="border-top: 1px solid var(--ia-line, #27272a); padding-top: 12px; background: rgba(59, 130, 246, 0.04); padding: 12px; border-radius: 6px; margin-top: 16px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
          <strong style="font-size: 0.85rem; color: var(--color-border-default);">CADASTRO TÉCNICO ASSISTIDO DE TUBULAÇÃO</strong>
          <label style="display: flex; align-items: center; gap: 6px; font-size: 0.8rem; color: var(--status-warning-text); cursor: pointer; background: rgba(245, 158, 11, 0.1); padding: 4px 8px; border-radius: 4px; border: 1px solid rgba(245, 158, 11, 0.3);">
            <input type="checkbox" id="dimensionSourceToggle" name="dimensionSourceToggle" ${eq.dimensionSource === 'MANUAL' ? 'checked' : ''} style="accent-color: var(--status-warning-text);">
            Modo Inclusão Manual (> 40" ou Especial)
          </label>
        </div>
        <input type="hidden" id="dimensionSource" name="dimensionSource" value="${eq.dimensionSource === 'MANUAL' ? 'MANUAL' : 'CATALOG'}">
        
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">DE (Origem) *</label>
            <input type="text" name="fromReference" required value="${(eq.fromReference || '').replace(/"/g, '&quot;')}" placeholder="Ex: Limite de bateria, V-101" style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);">
          </div>
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">PARA (Destino) *</label>
            <input type="text" name="toReference" required value="${(eq.toReference || '').replace(/"/g, '&quot;')}" placeholder="Ex: TQ-201 / Flange de Sucção" style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);">
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 8px;">
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">SPEC</label>
            <input type="text" id="spec" name="spec" value="${(eq.spec || '').replace(/"/g, '&quot;')}" placeholder="Ex: A1A" style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);">
          </div>
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">Classe de Pressão</label>
            <select id="pressureClass" name="pressureClass" style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);">
              <option value="">Selecione...</option>
              ${['150', '300', '400', '600', '900', '1500', '2500'].map(c => `<option value="${c}" ${eq.pressureClass === c ? 'selected' : ''}>${c}#</option>`).join('')}
            </select>
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin-top: 8px;">
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">FAMÍLIA DE MATERIAL *</label>
            <select id="materialFamily" name="materialFamily" required style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);">
              <option value="">Selecione...</option>
              ${families.map(f => `<option value="${f}" ${eq.materialFamily === f ? 'selected' : ''}>${f}</option>`).join('')}
            </select>
          </div>
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">ESPECIFICAÇÃO *</label>
            <select id="materialSpecification" name="materialSpecification" required style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);">
              <option value="">Selecione Família Primeiro...</option>
              ${specs.map(s => `<option value="${s}" ${eq.materialSpecification === s ? 'selected' : ''}>${s}</option>`).join('')}
            </select>
          </div>
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">GRAU *</label>
            <select id="materialGrade" name="materialGrade" required style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);">
              <option value="">Selecione Especificação Primeiro...</option>
              ${grades.map(g => `<option value="${g}" ${eq.materialGrade === g ? 'selected' : ''}>${g}</option>`).join('')}
            </select>
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 8px;">
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">CÓDIGO DE PROJETO</label>
            <input type="text" id="pipingProjectCode" name="pipingProjectCode" value="${(eq.projectCode || '').replace(/"/g, '&quot;')}" placeholder="Ex: ASME B31.3" style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);">
          </div>
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">NORMA DE FABRICAÇÃO</label>
            <input type="text" id="pipingFabricationStandard" name="pipingFabricationStandard" value="${(eq.fabricationStandard || '').replace(/"/g, '&quot;')}" placeholder="Ex: N-76" style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);">
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr; gap: 10px; margin-top: 8px;">
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">NPS *</label>
            <select id="nps-select" name="nps" required style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary); ${eq.dimensionSource === 'MANUAL' ? 'display: none;' : ''}" ${eq.dimensionSource === 'MANUAL' ? 'disabled' : ''}>
              <option value="">Selecione...</option>
              ${npsList.map(n => `<option value="${n.code}" ${eq.nps === n.code ? 'selected' : ''}>${n.label}</option>`).join('')}
            </select>
            <input type="text" id="nps-input" name="nps" required value="${eq.nps || ''}" placeholder="Ex: 42 pol" style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary); ${eq.dimensionSource === 'MANUAL' ? '' : 'display: none;'}" ${eq.dimensionSource === 'MANUAL' ? '' : 'disabled'}>
          </div>
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">SCHEDULE *</label>
            <select id="schedule-select" name="schedule" required style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary); ${eq.dimensionSource === 'MANUAL' ? 'display: none;' : ''}" ${eq.dimensionSource === 'MANUAL' ? 'disabled' : ''}>
              <option value="">Selecione NPS Primeiro...</option>
              ${schedules.map(s => {
                const sValue = s.value;
                const isSelected = (eq.schedule === null ? 'null' : eq.schedule) === (JSON.parse(sValue).schedule === null ? 'null' : JSON.parse(sValue).schedule) && eq.pipingDesignation === JSON.parse(sValue).designation;
                return `<option value='${sValue}' ${isSelected ? 'selected' : ''}>${s.label}</option>`;
              }).join('')}
            </select>
            <input type="text" id="schedule-input" name="schedule" required value="${eq.schedule || ''}" placeholder="Ex: STD" style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary); ${eq.dimensionSource === 'MANUAL' ? '' : 'display: none;'}" ${eq.dimensionSource === 'MANUAL' ? '' : 'disabled'}>
          </div>
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">CÓDIGO DE FABRICAÇÃO</label>
            <input type="text" id="fabricationCode" name="fabricationCode" value="${(eq.fabricationCode || '').replace(/"/g, '&quot;')}" placeholder="Ex: FAB-001" style="width: 100%; background: var(--color-input-bg); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);">
          </div>
          <div style="grid-column: span 2;">
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">NORMA DIMENSIONAL</label>
            <input type="text" id="dimensionalStandard" name="dimensionalStandard" value="${standard}" readonly style="width: 100%; background: rgba(255,255,255,0.05); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-disabled); cursor: not-allowed;">
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin-top: 8px;">
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">DIÂMETRO EXTERNO (mm) *</label>
            <input type="number" step="0.01" id="outsideDiameter" name="outsideDiameter" required value="${eq.outsideDiameter?.value || eq.outsideDiameter || ''}" ${eq.dimensionSource === 'MANUAL' ? '' : 'readonly'} style="width: 100%; background: ${eq.dimensionSource === 'MANUAL' ? 'var(--color-input-bg)' : 'rgba(255,255,255,0.05)'}; border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: ${eq.dimensionSource === 'MANUAL' ? 'var(--color-text-primary)' : 'var(--color-text-disabled)'}; ${eq.dimensionSource === 'MANUAL' ? '' : 'cursor: not-allowed;'}">
          </div>
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">ESPESSURA NOMINAL (mm) *</label>
            <input type="number" step="0.01" id="nominalThickness" name="nominalThickness" required value="${eq.nominalThickness?.value || eq.nominalThickness || ''}" ${eq.dimensionSource === 'MANUAL' ? '' : 'readonly'} style="width: 100%; background: ${eq.dimensionSource === 'MANUAL' ? 'var(--color-input-bg)' : 'rgba(255,255,255,0.05)'}; border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: ${eq.dimensionSource === 'MANUAL' ? 'var(--color-text-primary)' : 'var(--color-text-disabled)'}; ${eq.dimensionSource === 'MANUAL' ? '' : 'cursor: not-allowed;'}">
          </div>
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--color-text-disabled); margin-bottom: 2px;">DIÂMETRO INTERNO (mm)</label>
            <input type="number" step="0.01" id="calculatedInnerDiameter" name="calculatedInnerDiameter" value="${eq.calculatedInnerDiameter?.value || ''}" readonly style="width: 100%; background: rgba(255,255,255,0.05); border: 1px solid var(--color-input-border); border-radius: 4px; padding: 6px 10px; color: var(--color-text-disabled); cursor: not-allowed;">
          </div>
        </div>

        <div id="manual-justification-container" style="display: ${eq.dimensionSource === 'MANUAL' ? 'grid' : 'none'}; grid-template-columns: 1fr 2fr; gap: 10px; margin-top: 12px; padding-top: 12px; border-top: 1px dashed rgba(245, 158, 11, 0.3);">
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--status-warning-text); margin-bottom: 2px;">Fonte dos Dados Manuais *</label>
            <input type="text" id="dimensionManualSource" name="dimensionManualSource" value="${(eq.dimensionManualSource || '').replace(/"/g, '&quot;')}" placeholder="Ex: Desenho P&ID XYZ, Medição em campo" style="width: 100%; background: var(--color-input-bg); border: 1px solid rgba(245, 158, 11, 0.5); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);" ${eq.dimensionSource === 'MANUAL' ? 'required' : 'disabled'}>
          </div>
          <div>
            <label style="display: block; font-size: 0.75rem; color: var(--status-warning-text); margin-bottom: 2px;">Justificativa Técnica *</label>
            <input type="text" id="dimensionManualJustification" name="dimensionManualJustification" value="${(eq.dimensionManualJustification || '').replace(/"/g, '&quot;')}" placeholder="Ex: Tubulação customizada fabricada sob medida" style="width: 100%; background: var(--color-input-bg); border: 1px solid rgba(245, 158, 11, 0.5); border-radius: 4px; padding: 6px 10px; color: var(--color-text-primary);" ${eq.dimensionSource === 'MANUAL' ? 'required' : 'disabled'}>
          </div>
        </div>
      </div>
    `;
  }

  static bindPipingEvents(container: HTMLElement) {
    const familySel = container.querySelector('#materialFamily') as HTMLSelectElement;
    const specSel = container.querySelector('#materialSpecification') as HTMLSelectElement;
    const gradeSel = container.querySelector('#materialGrade') as HTMLSelectElement;
    const npsSel = container.querySelector('#nps-select') as HTMLSelectElement;
    const npsInput = container.querySelector('#nps-input') as HTMLInputElement;
    const schSel = container.querySelector('#schedule-select') as HTMLSelectElement;
    const schInput = container.querySelector('#schedule-input') as HTMLInputElement;
    const standardInput = container.querySelector('#dimensionalStandard') as HTMLInputElement;
    const odInput = container.querySelector('#outsideDiameter') as HTMLInputElement;
    const thickInput = container.querySelector('#nominalThickness') as HTMLInputElement;
    const diInput = container.querySelector('#calculatedInnerDiameter') as HTMLInputElement;
    const sourceToggle = container.querySelector('#dimensionSourceToggle') as HTMLInputElement;
    const sourceHidden = container.querySelector('#dimensionSource') as HTMLInputElement;
    const manualJustContainer = container.querySelector('#manual-justification-container') as HTMLElement;
    const manualSourceInput = container.querySelector('#dimensionManualSource') as HTMLInputElement;
    const manualJustInput = container.querySelector('#dimensionManualJustification') as HTMLInputElement;

    if (!familySel) return;

    const calcInternal = () => {
      const od = parseFloat(odInput.value);
      const thick = parseFloat(thickInput.value);
      if (!isNaN(od) && !isNaN(thick) && od > 0 && thick > 0) {
        diInput.value = pipingEngineeringService.calculateInnerDiameter(od, thick).toString();
      } else {
        diInput.value = '';
      }

      const mainCreate = document.querySelector('#create-nominal-thickness') as HTMLInputElement;
      if (mainCreate) mainCreate.value = thickInput.value;
      const mainEdit = document.querySelector('#edit-nominal-thickness') as HTMLInputElement;
      if (mainEdit) mainEdit.value = thickInput.value;
    };

    odInput.addEventListener('input', calcInternal);
    thickInput.addEventListener('input', calcInternal);

    const pipingProjectCodeInput = container.querySelector('#pipingProjectCode') as HTMLInputElement;
    const pipingFabricationStandardInput = container.querySelector('#pipingFabricationStandard') as HTMLInputElement;

    if (pipingProjectCodeInput) {
      pipingProjectCodeInput.addEventListener('input', () => {
        const val = pipingProjectCodeInput.value;
        const mainCreate = document.querySelector('#create-project-code') as HTMLInputElement;
        if (mainCreate) mainCreate.value = val;
        const mainEdit = document.querySelector('#edit-project-code') as HTMLInputElement;
        if (mainEdit) mainEdit.value = val;
        const detailEdit = document.querySelector('#detail-project-code') as HTMLInputElement;
        if (detailEdit) detailEdit.value = val;
      });
    }

    if (pipingFabricationStandardInput) {
      pipingFabricationStandardInput.addEventListener('input', () => {
        const val = pipingFabricationStandardInput.value;
        const mainCreate = document.querySelector('#create-fabrication-standard') as HTMLInputElement;
        if (mainCreate) mainCreate.value = val;
        const mainEdit = document.querySelector('#edit-fabrication-standard') as HTMLInputElement;
        if (mainEdit) mainEdit.value = val;
      });
    }

    sourceToggle?.addEventListener('change', () => {
      const isManual = sourceToggle.checked;
      sourceHidden.value = isManual ? 'MANUAL' : 'CATALOG';

      if (isManual) {
        npsSel.style.display = 'none';
        npsSel.disabled = true;
        npsInput.style.display = 'block';
        npsInput.disabled = false;

        schSel.style.display = 'none';
        schSel.disabled = true;
        schInput.style.display = 'block';
        schInput.disabled = false;

        odInput.readOnly = false;
        odInput.style.background = 'var(--color-input-bg)';
        odInput.style.color = 'var(--color-text-primary)';
        odInput.style.cursor = 'text';

        thickInput.readOnly = false;
        thickInput.style.background = 'var(--color-input-bg)';
        thickInput.style.color = 'var(--color-text-primary)';
        thickInput.style.cursor = 'text';

        manualJustContainer.style.display = 'grid';
        manualSourceInput.disabled = false;
        manualSourceInput.required = true;
        manualJustInput.disabled = false;
        manualJustInput.required = true;
      } else {
        npsSel.style.display = 'block';
        npsSel.disabled = false;
        npsInput.style.display = 'none';
        npsInput.disabled = true;

        schSel.style.display = 'block';
        schSel.disabled = false;
        schInput.style.display = 'none';
        schInput.disabled = true;

        odInput.readOnly = true;
        odInput.style.background = 'rgba(255,255,255,0.05)';
        odInput.style.color = 'var(--color-text-disabled)';
        odInput.style.cursor = 'not-allowed';

        thickInput.readOnly = true;
        thickInput.style.background = 'rgba(255,255,255,0.05)';
        thickInput.style.color = 'var(--color-text-disabled)';
        thickInput.style.cursor = 'not-allowed';

        manualJustContainer.style.display = 'none';
        manualSourceInput.disabled = true;
        manualSourceInput.required = false;
        manualJustInput.disabled = true;
        manualJustInput.required = false;
        
        // Re-trigger calculation from selects if possible
        npsSel.dispatchEvent(new Event('change'));
      }
    });

    familySel.addEventListener('change', () => {
      const family = familySel.value;
      if (!family) {
        specSel.innerHTML = '<option value="">Selecione Família Primeiro...</option>';
        gradeSel.innerHTML = '<option value="">Selecione Especificação Primeiro...</option>';
        return;
      }
      const specs = pipingEngineeringService.getSpecifications(family);
      specSel.innerHTML = '<option value="">Selecione...</option>' + specs.map(s => `<option value="${s}">${s}</option>`).join('');
      
      const standard = pipingEngineeringService.getDimensionalStandard(family);
      standardInput.value = standard;
      
      const npsList = pipingEngineeringService.getAvailableNPS(standard);
      const currentNps = npsSel.value;
      npsSel.innerHTML = '<option value="">Selecione...</option>' + npsList.map(n => `<option value="${n.code}">${n.label}</option>`).join('');
      if (currentNps && npsList.find(n => n.code === currentNps)) {
        npsSel.value = currentNps;
      } else {
        npsSel.value = '';
        npsSel.dispatchEvent(new Event('change'));
      }
    });

    specSel.addEventListener('change', () => {
      const family = familySel.value;
      const spec = specSel.value;
      if (!spec) {
        gradeSel.innerHTML = '<option value="">Selecione Especificação Primeiro...</option>';
        return;
      }
      const grades = pipingEngineeringService.getGrades(family, spec);
      gradeSel.innerHTML = '<option value="">Selecione...</option>' + grades.map(g => `<option value="${g}">${g}</option>`).join('');
    });

    npsSel.addEventListener('change', () => {
      const nps = npsSel.value;
      const standard = standardInput.value;
      if (!nps) {
        schSel.innerHTML = '<option value="">Selecione NPS Primeiro...</option>';
        odInput.value = '';
        thickInput.value = '';
        diInput.value = '';
        return;
      }
      const schedules = pipingEngineeringService.getAvailableSchedules(nps, standard);
      schSel.innerHTML = '<option value="">Selecione...</option>' + schedules.map(s => `<option value='${s.value}'>${s.label}</option>`).join('');
      
      // Quando selecionamos o NPS, o OD é comum entre os schedules de mesmo NPS e norma
      if (!sourceToggle.checked && schedules.length > 0) {
        const firstDim = pipingEngineeringService.getDimension(nps, schedules[0]?.value as string, standard);
        if (firstDim) {
          odInput.value = firstDim.od.toString();
        } else {
          odInput.value = '';
        }
        thickInput.value = '';
        diInput.value = '';
        calcInternal();
      }
    });

    schSel.addEventListener('change', () => {
      const nps = npsSel.value;
      const schVal = schSel.value;
      const standard = standardInput.value;
      if (!nps || !schVal) return;

      const dim = pipingEngineeringService.getDimension(nps, schVal, standard);
      if (dim && !sourceToggle.checked) {
        odInput.value = dim.od.toString();
        thickInput.value = dim.thickness.toString();
        diInput.value = pipingEngineeringService.calculateInnerDiameter(dim.od, dim.thickness).toString();
        
        const mainCreate = document.querySelector('#create-nominal-thickness') as HTMLInputElement;
        if (mainCreate) mainCreate.value = thickInput.value;
        const mainEdit = document.querySelector('#edit-nominal-thickness') as HTMLInputElement;
        if (mainEdit) mainEdit.value = thickInput.value;
      }
    });


  }
}
